
import {
    Component,
    Prop, Vue,
} from "@zoovu/runner-browser-api";

@Component
export default class QuestionBaseMixin extends Vue {
    @Prop()
    isFirstQuestion: boolean;

    @Prop()
    isLastQuestion: boolean;

    get componentStateClasses() {
        return {
            'is-first-question': this.isFirstQuestion,
            'is-last-question': this.isLastQuestion,
        };
    }
}
